import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSuccessGraphic = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 200 200",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_840_4488",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 200,
			height: 200,
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 100,
				cy: 100,
				r: 100,
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_840_4488)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M171.304 59.8022C171.304 59.8022 173.88 57.0189 175.41 57.4488C178.156 58.2205 177.976 60.2031 179.344 61.7106C180.713 63.2181 183.63 60.0333 185.16 60.5433C187.992 61.4877 186.019 63.8623 188.581 65.1144C189.526 65.5757 192.174 63.9703 192.174 63.9703",
					stroke: "#E5AFF3",
					strokeWidth: 4
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M45.0756 78.6231L50.6522 75.3866L53.8719 80.9924L48.2953 84.2289L45.0756 78.6231Z",
					fill: "#0254CF"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M188.909 93.8537L194.485 90.6171L197.705 96.223L192.128 99.4595L188.909 93.8537Z",
					fill: "#9EC5FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M59 19.4111C59 19.4111 61.8973 16.6278 63.6187 17.0577C66.7084 17.8294 66.5053 19.812 68.0449 21.3195C69.5845 22.827 72.867 19.6421 74.588 20.1522C77.7743 21.0966 75.5539 23.4711 78.4369 24.7233C79.499 25.1846 82.4783 23.5792 82.4783 23.5792",
					stroke: "#E5AFF3",
					strokeWidth: 4
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M147.585 52.5221C147.585 52.5221 147.984 48.4632 149.582 47.7398C152.448 46.4415 153.587 48.1742 155.749 48.4372C157.91 48.7001 158.342 44.076 159.991 43.4178C163.044 42.1992 162.896 45.5056 165.918 44.7252C167.032 44.4377 168.262 41.2821 168.262 41.2821",
					fill: "#9EC5FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M147.585 52.5221C147.585 52.5221 147.984 48.4632 149.582 47.7398C152.448 46.4415 153.587 48.1742 155.749 48.4372C157.91 48.7001 158.342 44.076 159.991 43.4178C163.044 42.1992 162.896 45.5056 165.918 44.7252C167.032 44.4377 168.262 41.2821 168.262 41.2821",
					stroke: "#9EC5FF",
					strokeWidth: 4
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M34.2744 52.7742L39.9717 54.987L39.141 48.8925L34.2744 52.7742Z",
					fill: "#9EC5FF",
					stroke: "#9EC5FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M157.296 162.54L156.915 169.437L163.16 166.421L157.296 162.54Z",
					fill: "#E5AFF3",
					stroke: "#E5AFF3"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M113.826 13.4199L119.453 11.0332L114.644 7.22924L113.826 13.4199Z",
					fill: "#9EC5FF",
					stroke: "#9EC5FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M132 34.3936L138.243 30.0002L138.957 37.8263L132 34.3936Z",
					fill: "#E5AFF3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M0 103.475C0 103.475 6.54462 103.597 11.3043 99.1304",
					stroke: "#E5AFF3",
					strokeWidth: 4
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M158.113 17.0241C158.113 17.0241 164.342 17.5479 168.354 22.8891",
					stroke: "#C2F4F1",
					strokeWidth: 4
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 166.956,
					cy: 77.3913,
					r: 1.73913,
					fill: "#E5AFF3"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 81.7391,
					cy: 151.304,
					r: 1.73913,
					fill: "#0254CF"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 180.87,
					cy: 145.217,
					r: 1.73913,
					fill: "#E5AFF3"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 23.4784,
					cy: 82.6087,
					r: 1.73913,
					fill: "#E5AFF3"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 95.6522,
					cy: 30.4348,
					r: 1.73913,
					fill: "#9EC5FF",
					stroke: "#9EC5FF"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 47.826,
					cy: 167.826,
					r: 1.73913,
					fill: "#9EC5FF",
					stroke: "#9EC5FF"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 29.9998,
					cy: 143.913,
					r: 5.65217,
					fill: "#E5AFF3",
					stroke: "#E5AFF3"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 65.0427,
					cy: 37.913,
					r: 3.47826,
					stroke: "#9EC5FF",
					strokeWidth: 2
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 179.131,
					cy: 120.87,
					r: 3.47826,
					stroke: "#E5AFF3",
					strokeWidth: 2
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 20.0002,
					cy: 114.783,
					r: 3.47826,
					fill: "#9EC5FF",
					stroke: "#9EC5FF",
					strokeWidth: 2
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 136.521,
					cy: 185.565,
					r: 3.47826,
					fill: "#9EC5FF",
					stroke: "#9EC5FF",
					strokeWidth: 2
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M100 150.047C72.4043 150.047 49.9529 127.596 49.9529 100C49.9529 72.4035 72.4043 49.9528 100 49.9528C127.596 49.9528 150.047 72.4035 150.047 100C150.047 127.596 127.596 150.047 100 150.047ZM100 41.7391C67.8751 41.7391 41.7393 67.875 41.7393 100C41.7393 132.125 67.8751 158.261 100 158.261C132.125 158.261 158.261 132.125 158.261 100C158.261 67.875 132.125 41.7391 100 41.7391Z",
			fill: "#146EF5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100 149.547C72.6804 149.547 50.4529 127.32 50.4529 100H49.4529C49.4529 127.872 72.1281 150.547 100 150.547V149.547ZM50.4529 100C50.4529 72.6796 72.6804 50.4528 100 50.4528V49.4528C72.1281 49.4528 49.4529 72.1273 49.4529 100H50.4529ZM100 50.4528C127.32 50.4528 149.547 72.6796 149.547 100H150.547C150.547 72.1273 127.872 49.4528 100 49.4528V50.4528ZM149.547 100C149.547 127.32 127.32 149.547 100 149.547V150.547C127.872 150.547 150.547 127.872 150.547 100H149.547ZM100 41.2391C67.599 41.2391 41.2393 67.5989 41.2393 100H42.2393C42.2393 68.1511 68.1513 42.2391 100 42.2391V41.2391ZM41.2393 100C41.2393 132.401 67.599 158.761 100 158.761V157.761C68.1513 157.761 42.2393 131.849 42.2393 100H41.2393ZM100 158.761C132.401 158.761 158.761 132.401 158.761 100H157.761C157.761 131.849 131.849 157.761 100 157.761V158.761ZM158.761 100C158.761 67.5989 132.401 41.2391 100 41.2391V42.2391C131.849 42.2391 157.761 68.1511 157.761 100H158.761Z",
			fill: "#146EF5"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M125.151 82.0674L92.558 114.474L78.3269 100.323C76.7205 98.7263 74.1159 98.7263 72.5095 100.323C70.9024 101.921 70.9024 104.51 72.5095 106.108L89.6497 123.15C90.4525 123.948 91.5056 124.348 92.558 124.348C93.6111 124.348 94.6642 123.948 95.467 123.15L130.968 87.8515C132.576 86.2543 132.576 83.6646 130.968 82.0674C129.363 80.4703 126.757 80.4703 125.151 82.0674Z",
			fill: "#146EF5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M125.151 82.0674L92.558 114.474L78.3269 100.323C76.7205 98.7263 74.1159 98.7263 72.5095 100.323C70.9024 101.921 70.9024 104.51 72.5095 106.108L89.6497 123.15C90.4525 123.948 91.5056 124.348 92.558 124.348C93.6111 124.348 94.6642 123.948 95.467 123.15L130.968 87.8515C132.576 86.2543 132.576 83.6646 130.968 82.0674C129.363 80.4703 126.757 80.4703 125.151 82.0674",
			stroke: "#146EF5"
		})
	]
});
export default SvgSuccessGraphic;
